export const hotRankDaily = [
  {
    rank: 1,
    title: '深夜聚餐同框路透，时间线已补至第四段',
    category: '明星八卦',
    heat: '26.8万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20camera%20flash%20burst%20and%20torn%20paper%20collage%20on%20deep%20crimson%20background%2C%20editorial%20art%20direction%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '综艺未播片段外泄，嘉宾临场反应成焦点',
    category: '娱乐瓜',
    heat: '18.4万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20clapperboard%20and%20popcorn%20over%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '直播间早年发言被翻出，语境引发两派争论',
    category: '网红历史',
    heat: '12.7万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20glowing%20screen%20and%20chat%20bubbles%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '剧组探班目击记录公开，后台细节被逐条比对',
    category: '素人爆料',
    heat: '9.6万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20sealed%20envelope%20and%20microphone%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '品牌活动座位线索被解读，多方给出不同版本',
    category: '明星八卦',
    heat: '7.3万',
    trend: 'down',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20spotlight%20beam%20and%20velvet%20rope%20on%20deep%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-05&orientation=landscape',
  },
  {
    rank: 6,
    title: '账号改名时间线被整理，早期合作记录同步曝光',
    category: '网红历史',
    heat: '5.1万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20floating%20timeline%20cards%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-06&orientation=landscape',
  },
];

export const hotRankWeekly = [
  {
    rank: 1,
    title: '选秀票数争议持续一周，官方两次发布说明',
    category: '娱乐瓜',
    heat: '88.2万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20spotlight%20stage%20with%20torn%20paper%20rings%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w1&orientation=landscape',
  },
  {
    rank: 2,
    title: '网红旧账号连续被翻，话题热度居高不下',
    category: '网红历史',
    heat: '64.5万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20archive%20folders%20and%20notification%20cards%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w2&orientation=landscape',
  },
  {
    rank: 3,
    title: '同框路透连续发酵，时间线被不断补充',
    category: '明星八卦',
    heat: '52.1万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20camera%20lens%20and%20flash%20cards%20on%20deep%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w3&orientation=landscape',
  },
  {
    rank: 4,
    title: '探班类投稿集中出现，现场记录成为主流线索',
    category: '素人爆料',
    heat: '37.6万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20photo%20prints%20and%20clip%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w4&orientation=landscape',
  },
  {
    rank: 5,
    title: '直播切片考古成热门玩法，语境比对受关注',
    category: '娱乐瓜',
    heat: '29.3万',
    trend: 'down',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20video%20tape%20reels%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w5&orientation=landscape',
  },
  {
    rank: 6,
    title: '音乐节后台素材流出，主办方称正在核查',
    category: '明星八卦',
    heat: '21.8万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20backstage%20pass%20and%20spotlight%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-w6&orientation=landscape',
  },
];

export const hotRankMonthly = [
  {
    rank: 1,
    title: '整月「考古」类线索集中爆发，人设议题持续升温',
    category: '网红历史',
    heat: '212万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20stack%20of%20archive%20cards%20and%20magnifier%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m1&orientation=landscape',
  },
  {
    rank: 2,
    title: '暑期档路透密度上升，同框类线索明显增多',
    category: '明星八卦',
    heat: '186万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20summer%20spotlight%20and%20ticket%20stubs%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m2&orientation=landscape',
  },
  {
    rank: 3,
    title: '综艺类素材投稿量稳居第一，剪辑争议最易上榜',
    category: '娱乐瓜',
    heat: '158万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20film%20editing%20timeline%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m3&orientation=landscape',
  },
  {
    rank: 4,
    title: '素人爆料占比上升，现场目击类更受编辑青睐',
    category: '素人爆料',
    heat: '121万',
    trend: 'up',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20voice%20recorder%20and%20notes%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m4&orientation=landscape',
  },
  {
    rank: 5,
    title: '聊天记录类素材整理成本高，但曝光转化最好',
    category: '素人爆料',
    heat: '96万',
    trend: 'flat',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20chat%20bubble%20cards%20floating%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m5&orientation=landscape',
  },
  {
    rank: 6,
    title: '票数、花絮、后台三类关键词整月高频出现',
    category: '娱乐瓜',
    heat: '78万',
    trend: 'down',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20keyword%20cards%20and%20spotlight%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=480&height=360&seq=hl-hot-m6&orientation=landscape',
  },
];